module.exports = __webpack_public_path__ + "img/fail.dcd36bf7.svg";